import { useEffect, useRef } from 'react';
import TextoRico from './TextoRico';

interface CampoAreaProps {
  id: string;
  name: string;
  label: string;
  help?: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  error?: string | null;
  placeholder?: string;
  maxLength?: number;
  simples?: boolean;
}

const ALTURA_LINHA = 24;
const MAX_LINHAS = 12;
const LIMITE_CONTADOR = 300;

export default function CampoArea({
  id,
  name,
  label,
  help,
  value,
  onChange,
  required,
  error,
  placeholder,
  maxLength,
  simples,
}: CampoAreaProps) {
  const ref = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = `${Math.min(el.scrollHeight, MAX_LINHAS * ALTURA_LINHA)}px`;
  }, [value]);

  return (
    <div>
      <label htmlFor={id} className="block text-base font-medium text-foreground-950">
        {label} {required && <span className="text-danger-600">*</span>}
      </label>
      {help && <p className="mt-1 text-sm text-secondary-500">{help}</p>}
      <textarea
        ref={ref}
        id={id}
        name={name}
        rows={3}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        maxLength={maxLength}
        className={`mt-1 w-full resize-none overflow-auto rounded-md border bg-white px-3 py-2 text-[15px] text-foreground-950 outline-none transition-colors placeholder:text-secondary-400 focus:border-primary-500 ${
          error ? 'border-danger-500' : 'border-secondary-300'
        }`}
      />

      {simples ? (
        maxLength && (
          <p className="mt-1 text-right text-xs text-secondary-400">
            {value.length}/{maxLength} caracteres
          </p>
        )
      ) : (
        <>
          <p className="mt-1 text-xs text-secondary-400">
            Enter pula linha. Use **asteriscos duplos** para deixar em negrito.
          </p>
          {value.length > LIMITE_CONTADOR && (
            <p className="mt-1 text-xs text-secondary-400">{value.length} caracteres</p>
          )}
          {value.trim() && (
            <div className="mt-2 rounded-md border border-secondary-200 bg-secondary-50 px-3 py-2">
              <p className="text-xs font-medium uppercase tracking-wide text-secondary-500">
                Como o participante vai ver:
              </p>
              <TextoRico texto={value} className="mt-1 text-sm text-foreground-800" />
            </div>
          )}
        </>
      )}

      {error && (
        <p className="mt-1 text-sm text-danger-600" role="alert" data-erro="true">
          {error}
        </p>
      )}
    </div>
  );
}